import {
    Alert,
    Avatar,
    Badge, Box,
    Card,
    Flex,
    Heading,
    HStack,
    Icon, IconButton, Menu,
    Progress,
    Skeleton,
    SkeletonCircle,
    SkeletonText, Stack,
    Text,
    VStack
} from "@chakra-ui/react";

import {Button, CloseButton, Dialog, Portal} from "@chakra-ui/react"
import {FiMapPin} from "react-icons/fi";
import {GiFruitBowl} from "react-icons/gi";
import React, {useState} from "react";
import {FaChevronDown, FaChevronUp, FaEllipsisV, FaFileExcel, FaFilePdf} from "react-icons/fa";

const baseUrl = process.env.REACT_APP_API_URL;

const FarmerInformationE = ({cardBg, applicant, loading, application, isLoadingAppplication}) => {
    const [loadingPdf, setLoadingPdf] = useState({});
    const [loadingExcel, setLoadingExcel] = useState({});
    const token = localStorage.getItem("token");
    const toSentenceCase = (str) => {
        return str
            .toLowerCase()
            .split(' ')
            .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
            .join(' ');
    };

    const keyLabels = {
        nombre: 'Name',
        apellido_paterno: 'Last Name',
        // apellido_materno: 'Apellido Materno',
        vigencia_ine: 'ID Valid',
        fecha_nacimiento: 'Date of Birth',
        // rfc: 'RFC',
        // curp: 'CURP',
        domicilio: 'Address',
        puntaje_fico: 'FICO Score',
        antiguedad_crediticia: 'Credit History',
        // razones_score: 'Razones del Score',
        mayor_aprobado: 'Maximum Approved Amount',
        recomendacion: 'Recommendation',
    };

    const handleDownload = async (s3Key, fileType, appId) => {
        if (!s3Key) return;

        try {
            if (fileType === "pdf") setLoadingPdf((prev) => ({...prev, [appId]: true}));
            else setLoadingExcel((prev) => ({...prev, [appId]: true}));

            const encodedKey = encodeURIComponent(s3Key);
            const response = await fetch(`${baseUrl}/application/file/download/?s3_key=${encodedKey}`, {
                method: "GET",
                headers: {
                    Authorization: `Bearer ${token}`,
                    app_origin: "caz",
                },
            });

            const data = await response.json();
            window.open(data.url, "_blank");
        } catch (error) {
            console.error("Download error:", error);
        } finally {
            if (fileType === "pdf") setLoadingPdf((prev) => ({...prev, [appId]: false}));
            else setLoadingExcel((prev) => ({...prev, [appId]: false}));
        }
    };

    return (
        <Card.Root bg={cardBg} borderRadius="xl">
            <Card.Body>
                <Flex direction="column" alignItems="center" textAlign="center">
                    {loading ? (
                        <>
                            <SkeletonCircle size="20" mb={4}/>
                            <Skeleton height="20px" width="60%" mb={2}/>
                            <Skeleton height="16px" width="40%" mb={4}/>

                            <HStack spacing={4} mb={4}>
                                <VStack>
                                    <SkeletonText noOfLines={1} spacing="2" width="60px"/>
                                    <SkeletonText noOfLines={1} spacing="2" width="40px"/>
                                </VStack>
                                <VStack>
                                    <SkeletonText noOfLines={1} spacing="2" width="80px"/>
                                    <SkeletonText noOfLines={1} spacing="2" width="50px"/>
                                </VStack>
                            </HStack>

                            <VStack spacing={4} mb={4}>
                                <VStack>
                                    <SkeletonText noOfLines={1} spacing="2" width="100px"/>
                                    <SkeletonText noOfLines={1} spacing="2" width="80px"/>
                                </VStack>
                                <VStack>
                                    <SkeletonText noOfLines={1} spacing="2" width="120px"/>
                                    <SkeletonText noOfLines={1} spacing="2" width="100px"/>
                                </VStack>
                            </VStack>

                            {/*<Badge colorPalette="purple" mb={4} px={3} py={1} borderRadius="full">*/}
                            {/*    <Icon as={GiFruitBowl} mr={2}/> {agricultor.tipoAgricultura}*/}
                            {/*</Badge>*/}

                            <VStack spacing={2} w="full" mb={4}>
                                <SkeletonText noOfLines={1} width="40%"/>
                                <Skeleton height="8px" width="100%" borderRadius="full"/>
                                <HStack w="full" justifyContent="space-between">
                                    <SkeletonText noOfLines={1} width="20px"/>
                                    <SkeletonText noOfLines={1} width="20px"/>
                                </HStack>
                            </VStack>

                            {/*<Badge*/}
                            {/*    colorPalette={agricultor.riesgo === "Alto" ? "red" : agricultor.riesgo === "Medio" ? "orange" : "green"}*/}
                            {/*    px={3} py={1}>*/}
                            {/*    Riesgo: {agricultor.riesgo}*/}
                            {/*</Badge>*/}
                        </>
                    ) : (
                        <>
                            <Avatar.Root
                                size="xl"
                                shape="full"
                                mb={4}
                                borderWidth="2px"
                                borderColor="white"
                                boxShadow="md"
                            >
                                <Avatar.Image
                                    // src={agricultor.imagen}
                                    onError={(e) => {
                                        e.currentTarget.style.display = 'none'
                                    }}
                                />
                                <Avatar.Fallback
                                    name={applicant?.applicant}
                                    bgGradient="linear(to-br, teal.400, teal.600)"
                                    color="white"
                                    fontSize="xl"
                                    fontWeight="bold"
                                />
                            </Avatar.Root>
                            <Heading as="h2" size="md" mb={1}>{applicant?.applicant}</Heading>
                            <Text fontSize="sm" color="gray.500" mb={4}>
                                <Icon as={FiMapPin} mr={1}/> {applicant?.meta?.location}
                            </Text>

                            <HStack spacing={4} mb={4}>
                                <VStack>
                                    <Text fontSize="sm" color="gray.500">Age</Text>
                                    <Text fontWeight="bold">{applicant?.meta?.age} years</Text>
                                </VStack>
                                <VStack>
                                    <Text fontSize="sm" color="gray.500">Experience</Text>
                                    <Text fontWeight="bold">{applicant?.meta?.experience} years</Text>
                                </VStack>
                            </HStack>

                            <VStack spacing={4} mb={4}>
                                <VStack>
                                    <Text fontSize="sm" color="gray.500">Phone Number</Text>
                                    <Text fontWeight="bold">{applicant?.meta?.phone_number}</Text>
                                </VStack>
                                <VStack>
                                    <Text fontSize="sm" color="gray.500">E-mail</Text>
                                    <Text fontWeight="bold">{applicant?.meta?.email}</Text>
                                </VStack>
                            </VStack>

                            {/*<Badge colorPalette="purple" mb={4} px={3} py={1} borderRadius="full">*/}
                            {/*    <Icon as={GiFruitBowl} mr={2}/> {agricultor.tipoAgricultura}*/}
                            {/*</Badge>*/}

                            <VStack spacing={2} w="full" mb={4}>
                                <HStack w="full" justifyContent="space-between">
                                    <Text fontSize="sm">FICO Score:</Text>
                                    <Text fontWeight="bold">{applicant?.meta?.fico_score}</Text>
                                </HStack>
                                {applicant && (<Progress.Root
                                    value={applicant?.meta?.fico_score / 8.5}
                                    max={100}
                                    w="full"
                                    size="sm"
                                >
                                    <HStack justify="space-between" w="full">
                                        <Progress.Label srOnly>FICO Score</Progress.Label>
                                        <Progress.Track flex="1" borderRadius="full">
                                            <Progress.Range
                                                bg="teal.500"
                                                borderRadius="inherit"
                                            />
                                        </Progress.Track>
                                        <Progress.ValueText
                                            minW="8"
                                            textAlign="right"
                                            fontSize="sm"
                                        >
                                            {Math.round(applicant?.meta?.fico_score / 8.5)}%
                                        </Progress.ValueText>
                                    </HStack>
                                </Progress.Root>)}
                                <HStack w="full" justifyContent="space-between">
                                    <Text fontSize="xs" color="gray.500">300</Text>
                                    <Text fontSize="xs" color="gray.500">850</Text>
                                </HStack>
                            </VStack>
                            {/*<VStack spacing={4} align="stretch">*/}
                            {/*    <Dialog.Root>*/}
                            {/*        <Dialog.Trigger asChild>*/}
                            {/*            <Button variant="outline" size="sm" loading={isLoadingAppplication}>*/}
                            {/*                More Information*/}
                            {/*            </Button>*/}
                            {/*        </Dialog.Trigger>*/}
                            {/*        <Portal>*/}
                            {/*            <Dialog.Backdrop/>*/}
                            {/*            <Dialog.Positioner>*/}
                            {/*                <Dialog.Content>*/}
                            {/*                    <Dialog.Header>*/}
                            {/*                        <Dialog.Title px={4}>Applicant Information</Dialog.Title>*/}
                            {/*                    </Dialog.Header>*/}
                            {/*                    <Dialog.Body>*/}
                            {/*                        {application && (*/}
                            {/*                            <Box px={4} bg="white" borderRadius="md" w="full" maxW="600px">*/}
                            {/*                                <Stack gap={4} width="full">*/}
                            {/*                                    /!*<Button onClick={handleNewProcess} colorPalette="teal" w="full">*!/*/}
                            {/*                                    /!*    Procesar nueva solicitud*!/*/}
                            {/*                                    /!*</Button>*!/*/}
                            {/*                                    <Box bg="white">*/}

                            {/*                                        {Object.entries(JSON.parse(application?.onboarding?.general_info?.formulario)).map(([key, value], index) => {*/}
                            {/*                                            if (value === 'N/A' || !value) return null;*/}
                            {/*                                            const sentenceCaseKeys = ['domicilio', 'nombre', 'apellido_paterno', 'apellido_materno', 'vigencia_ine']*/}

                            {/*                                            const formattedValue =*/}
                            {/*                                                sentenceCaseKeys.includes(key)*/}
                            {/*                                                    ? toSentenceCase(value)*/}
                            {/*                                                    : Array.isArray(value)*/}
                            {/*                                                        ? value.join(', ')*/}
                            {/*                                                        : value;*/}

                            {/*                                            const displayLabel = keyLabels[key] || key;*/}

                            {/*                                            return (*/}
                            {/*                                                <Box key={index} mb={2}>*/}
                            {/*                                                    <Text fontWeight="medium"*/}
                            {/*                                                          fontSize="medium"*/}
                            {/*                                                          color="gray.800">*/}
                            {/*                                                        {displayLabel}*/}
                            {/*                                                    </Text>*/}
                            {/*                                                    <Box*/}
                            {/*                                                        borderWidth="1px"*/}
                            {/*                                                        borderRadius="sm"*/}
                            {/*                                                        p={1}*/}
                            {/*                                                        px={2}*/}
                            {/*                                                        bg="white"*/}
                            {/*                                                        color="gray.800"*/}
                            {/*                                                        fontWeight="normal"*/}
                            {/*                                                        fontSize="sm"*/}
                            {/*                                                    >*/}
                            {/*                                                        {formattedValue}*/}
                            {/*                                                    </Box>*/}
                            {/*                                                </Box>*/}
                            {/*                                            );*/}
                            {/*                                        })}*/}
                            {/*                                    </Box>*/}
                            {/*                                    <Text fontWeight={"medium"} fontSize={"md"}>Download*/}
                            {/*                                        Documents</Text>*/}
                            {/*                                    <HStack spacing={2}>*/}

                            {/*                                        <Button*/}
                            {/*                                            variant="outline"*/}
                            {/*                                            loading={loadingPdf[application.id]}*/}
                            {/*                                            loadingText=""*/}
                            {/*                                            onClick={() => handleDownload(application?.onboarding?.general_info.pdf_key, "pdf", application.id)}*/}
                            {/*                                        >*/}
                            {/*                                            <FaFilePdf color={"crimson"}/>*/}
                            {/*                                        </Button>*/}
                            {/*                                        <Button*/}
                            {/*                                            variant="outline"*/}
                            {/*                                            loading={loadingExcel[application.id]}*/}
                            {/*                                            loadingText=""*/}
                            {/*                                            onClick={() => handleDownload(application?.onboarding?.general_info.excel_key, "excel", application.id)}*/}
                            {/*                                        >*/}
                            {/*                                            <FaFileExcel color={"darkgreen"}/>*/}
                            {/*                                        </Button>*/}
                            {/*                                    </HStack>*/}
                            {/*                                </Stack>*/}
                            {/*                            </Box>*/}
                            {/*                        )}*/}
                            {/*                    </Dialog.Body>*/}
                            {/*                    /!*<Dialog.Footer>*!/*/}
                            {/*                    /!*    <Dialog.ActionTrigger asChild>*!/*/}
                            {/*                    /!*        <Button variant="outline">Cancel</Button>*!/*/}
                            {/*                    /!*    </Dialog.ActionTrigger>*!/*/}
                            {/*                    /!*    <Button>Save</Button>*!/*/}
                            {/*                    /!*</Dialog.Footer>*!/*/}
                            {/*                    <Dialog.CloseTrigger asChild>*/}
                            {/*                        <CloseButton size="sm"/>*/}
                            {/*                    </Dialog.CloseTrigger>*/}
                            {/*                </Dialog.Content>*/}
                            {/*            </Dialog.Positioner>*/}
                            {/*        </Portal>*/}
                            {/*    </Dialog.Root>*/}
                            {/*</VStack>*/}

                            {/*<Badge*/}
                            {/*    colorPalette={agricultor.riesgo === "Alto" ? "red" : agricultor.riesgo === "Medio" ? "orange" : "green"}*/}
                            {/*    px={3} py={1}>*/}
                            {/*    Riesgo: {agricultor.riesgo}*/}
                            {/*</Badge>*/}
                        </>
                    )}
                </Flex>
            </Card.Body>
        </Card.Root>
    );
};

export default FarmerInformationE;
